import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoginStatus } from './login-status-service';


@Injectable({ providedIn: 'root' })
export class AccountGuardService  {

  private loggedIn = false;

  private _LoginStatus = inject(LoginStatus);
  private _Router = inject(Router);

  constructor() {
    this._LoginStatus.loggedIn.subscribe((val) => {
      this.loggedIn = val;
    });
  }


  canActivate(): boolean {

    if (this.loggedIn || !!sessionStorage.getItem('accessToken')) {
      return true;
    }

    this._Router.navigate(['/login']);
    return false;

  }

}
